import { useState,useRef,useEffect, useMemo } from 'react';
import { namespaceState } from '../../recoil/atoms';
import { useRecoilState } from 'recoil';
import styles from './ModelList.module.css'
import dateFormat from '../../utils/dateFormat';
import getByteSize from '../../utils/getByteSize';
import UploadBtn from './UploadBtn';
import useApi from '../../services/useApi';
import ConfirmModal from '../../compoenets/ConfirmModal';
import ToolTip from '../../compoenets/ToolTip';

const ListBodyRow = ({
  data,
  type="base",
  index,
  onClick,
  onDelete,
  modelItemToggle,
  listUpdate,
  refreshModelList
}) => {

  const handleClick=(()=>{
    if(data.status!==0)return;
    
    if(type==='sub'){
      onClick(index,"Task: "+data.task.taskName+" Round Num: "+data.task.roundNum,data.modelId)

    }else{
      onClick(index,data.name,data.modelId)
    }
  })
  return (
    <tr onClick={handleClick} 
    className={`
    ${modelItemToggle === data.modelId && styles['list-body-tr-on']} 
    ${listUpdate && (index===0 ? styles["list-body-fadeIn"]:styles["list-body-fadeDown"])}`}>
      <td className={styles['col-name']}> 
        {type==='sub'?<>
        <div className={styles['col-name-label']}>Sub Model</div>
        <ToolTip>{"Task: "+data.task.taskName+" Round Num: "+data.task.roundNum}</ToolTip>
        </>:<ToolTip>{data.name}</ToolTip>
        }
      </td>
      <td>{dateFormat(data.createdTime).date.substring(0,11)}</td>
      <td>{getByteSize(data.tfModel.size)}</td>
      <td className={`${data.status===0?styles['model-available']:data.status===1?styles['model-checking']:styles['model-disable']}`}></td>
      <td><div className={styles['list-body-delete']} onClick={()=>onDelete(data)}></div></td>
    </tr>
  )
}

export default function ModelList({modelList,modelItemToggle,handleModelItem,requiredItemToggle,refreshModelList}){
    const [nsState,setNsState]=useRecoilState(namespaceState);
    const [listUpdate,setListUpdate]=useState(false);
    const [isConfirm,setIsConfirm]=useState(false);
    const [deleteModel,setDeleteModel]=useState(null);
    const userId=JSON.parse(localStorage.getItem("account")).id;
    const handleDelete=(e)=>{
      // modelRegistry
      useApi.delete('ngp/modelreg/mm/model/v1/model?namespaceId='+nsState.id+"&modelId="+deleteModel.modelId+"&userId="+userId).then((res)=>{
        refreshModelList();
        setDeleteModel(null);
        setIsConfirm(false);
      })
    }

    const handleConfirm=(data)=>{
      setIsConfirm(true);
      setDeleteModel(data);
    }

    useEffect(()=>{
      if(deleteModel!==null)return;
      setIsConfirm(false);
    },[deleteModel])

    return(
        <div className={styles["body-model"]}>
          <div className={styles["model-head"]}>
            <span>Available Model</span>
          </div>
          <div className={`${styles["model-list-wrap"]} ${(modelItemToggle!==-1 && requiredItemToggle!==0) && styles['model-list-wrap-on']}`}>
            { requiredItemToggle===0 && <div className={styles["model-list-empty"]}><div></div><div><span>Select</span><span>Required Data</span></div></div>}
            <div className={styles["model-list-table-wrap"]}>
              <table className={styles["model-list"]}>
                <thead className={styles["list-head"]}>
                  <tr className={styles["list-head-row"]}>
                    <th>Name</th>
                    <th>Date</th>
                    <th>Size</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody className={`${styles["list-body"]} ${requiredItemToggle !==0 && styles["list-body-on"]}`}>
                  { modelList.map((modelListRow,index) =>
                  <>
                  <ListBodyRow 
                  data={modelListRow} 
                  index={index} 
                  onClick={handleModelItem} 
                  modelItemToggle={modelItemToggle}
                  listUpdate={listUpdate}
                  refreshModelList={refreshModelList}
                  onDelete={handleConfirm}
                  />
                  {modelListRow?.subModels?.map((subModel,index)=>
                  <ListBodyRow
                    data={subModel} 
                    type="sub"
                    index={index} 
                    onClick={handleModelItem} 
                    modelItemToggle={modelItemToggle}
                    listUpdate={listUpdate}
                    refreshModelList={refreshModelList}
                    onDelete={handleConfirm}
                  />)}
                  </>
                  )}
                </tbody>
              </table>
            </div>
            { requiredItemToggle===1 && <UploadBtn refreshModelList={refreshModelList}/> }
          </div>
          {isConfirm&&<ConfirmModal
          title="Model Delete"
          subTitle={"모델 `"+`${deleteModel.name}`+"`을 삭제하겠습니까?"}
          confirmText="Delete"
          cancelText="Cancel"
          onAction={handleDelete}
          onClose={()=>setIsConfirm(false)}
          />
          }
        </div>
    )
}